export const ActionTypes = {
  LOADING: "GET_SHORTLISTS_LOADING",
  ERROR: "GET_SHORTLISTS_ERROR",
  SUCCESS: "GET_SHORTLISTS_SUCCESS",
};
